.root {
  text-transform: none;
}

.root[data-variant='grey'] {
  background-color: var(--mantine-color-gray-1);
  border: 1px solid var(--mantine-color-gray-3);
  color: var(--mantine-color-gray-8);
}

.root[data-variant='green'],
.root[data-variant='green-clickable'] {
  background-color: var(--mantine-color-green-1);
  border: 1px solid var(--mantine-color-green-3);
  color: var(--mantine-color-green-8);
}

.root[data-variant='green-clickable'] {
  cursor: pointer;
}

.root[data-variant='green-clickable']:hover {
  background-color: var(--mantine-color-green-2);
  border-color: var(--mantine-color-green-4);
}

.root[data-variant='warning'] {
  background-color: var(--mantine-color-warning-1);
  border: 1px solid var(--mantine-color-warning-3);
  color: var(--mantine-color-warning-8);
}
